import { gql } from '@/__generated__';

const SEND_SMA_REPORTS_EXCEL_BY_EMAIL = gql(`#graphql
  mutation TriggerSMAReport($input: TriggerSMAReportInput!) {
    triggerSMAReport(input: $input) {
      success
    }
  }
`);

export default SEND_SMA_REPORTS_EXCEL_BY_EMAIL;
